<template>
	<div>
		<Header />
		<div class="banners">
			<Banner :src="src" />
		</div>
		
		<div class="con3" style="padding-top: 10px">
			<div class="conter">
				<div class="news_nr_left">
					<h1>{{result.length && result[0].bd_titlecn}}</h1>
					<p class="news_inf">发表时间：{{result.length && result[0].bd_publishdatetime}}</p>
					<div class="news_nrn">
						<p v-html="content"></p>
						
					</div>
					<div class="next">
						<router-link v-if="prev_title" :to="`/home/news/${prev_url}`">上一篇：{{prev_title}}</router-link>

						<router-link v-if="next_title" :to="`/home/news/${next_url}`"  class="f_r">下一篇：{{next_title}}</router-link>
					</div>
				</div>
				<div class="clears"></div>
			</div>
		</div>

		<Footer />
	</div>
</template>
<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Axios from 'axios'
import Vue from 'vue'
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
const Base64=require('js-base64')
export default {
	components: { Header, Banner, Footer },
	data() {
		return {
			src:'',
			new_list:[],
			result:[],
			next_url:'',
			prev_url:'',
			prev_title:'',
			next_title:'',
			content:''

		}
	},
	
	watch:{
		$route(to,from){
			this.$router.go(0)
		}
	},
	created(){
		this.init()
	},
	mounted(){
		let picSrc=JSON.parse(window.sessionStorage.getItem('commonContent'))
		for(var i=0;i<picSrc.length;i++){
			if (picSrc[i].sc_key.slice(0, 13) == 'NEWDETAILPIC') {
					this.src =picSrc[i].sc_value
				}
		};
		Axios({
			url: '/apiv2/bdoc/getone?bdAtpid='+this.$route.params.id,
			data: {},
			method: 'GET',
		}).then((res) => {
			this.content=Base64.decode(res.data.data.bdContentcn).replaceAll("<a","<a rel='noopener noreferrer'")
		})
	},
	methods:{
		init(){
			Axios({
			url: '/apiv2/bdoc/getlist?bdContenttype=新闻',
			data: {},
			method: 'GET',
		}).then((res) => {
				this.new_list=res.data.data.rows;
				for(var k=0;k<this.new_list.length;k++){
					this.new_list[k].bd_coverpicturecn=this.new_list[k].bd_coverpicturecn
					//this.new_list[k].bd_contentcn=Base64.decode(this.new_list[k].bd_contentcn)
					this.new_list[k].bd_atpcreatedatetime=this.new_list[k].bd_atpcreatedatetime.slice(0,7)
					this.new_list[k].bd_atplastmodifydatetime=this.new_list[k].bd_atplastmodifydatetime.slice(8,10)
				}
				this.result = this.findItem(this.new_list,this.$route.params.id);
				this.new_list.map((item,index)=>{
					if(item.bd_atpid == this.$route.params.id){
						if(index==0){
							this.next_url = this.new_list[index+1].bd_atpid
							this.prev_url = ''
							this.prev_title = ''
							this.next_title = this.new_list[index+1].bd_titlecn
						}else if(index == this.new_list.length-1){
							this.prev_url = this.new_list[index-1].bd_atpid
							this.next_url = ''
							this.next_title = ''
							this.prev_title = this.new_list[index-1].bd_titlecn
						} else{
							this.next_url = this.new_list[index+1].bd_atpid
							this.prev_url = this.new_list[index-1].bd_atpid
							this.prev_title = this.new_list[index-1].bd_titlecn
							this.next_title = this.new_list[index+1].bd_titlecn
						}
					}
				})
		})
		},
		findItem(arr,query){
			return arr.filter(item=>item.bd_atpid.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1)
		},
	}
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	.path {
		height: 30px;
		line-height: 30px;
		padding-left: 12px;
		font-size: 14px;
		color: #666;
		margin-bottom: 20px;
	}
	.news_nr_left {
		background: #fff;
		padding: 30px 50px;
	}
	.news_nr_left h1 {
		font-family: Microsoft Yahei;
		font-size: 22px;
		text-align: center;
		line-height: 2em;
		font-weight: normal;
		border-bottom: 1px dotted #ddd;
		padding-bottom: 10px;
	}
	.news_nr_left p.news_inf {
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #666;
	}
	.news_nrn {
		width:75%;
		margin: 0 auto;
		font-size: 15px;
		line-height: 2em;
	}
	.news_nrn p {
		margin-top: 20px;
	}
	.news_nrn img {
		margin: 20px auto 0;
		border: 0;
	}
	.news_nrn p.others {
		text-align: right;
	}
	.news_nrn p a {
		color: #274a7d;
	}
	.next {
		height: 30px;
		clear: both;
		font-size: 14px;
		margin-top: 50px;
		border-top: 1px dotted #ddd;
		border-bottom: 1px dotted #ddd;
		margin-bottom: 20px;
		padding-bottom: 10px;
		padding-top: 20px;
	}
	.next a.f_r {
		float: right;
	}
	.next a:hover {
		text-decoration: none;
		color: #274a7d;
	}
	.type_info {
		font-size: 14px;
		line-height: 2em;
	}

	.news_nr_right {
		width: 292px;
		float: right;
		border: 1px solid #d5d5d5;
		background: #fff;
	}

	.tab1 {
		font-family: Microsoft Yahei;
	}
	.tab1 h3 {
		height: 30px;
		padding-left: 12px;
		background: #e2e2e2;
		line-height: 30px;
		font-size: 14px;
	}
	.tab1 ul {
		padding: 12px 5px 10px 15px;
	}
	.tab1 ul li {
		height: 30px;
	}
	.tab1 ul li a {
		color: #666666;
		font-size: 13px;
	}
	.tab1 ul li b {
		display: block;
		width: 15px;
		height: 15px;
		text-align: center;
		line-height: 15px;
		color: #fff;
		background: #999;
		float: left;
		font-weight: normal;
		margin-right: 10px;
		margin-top: 3px;
	}
	.tab1 ul li b.r {
		background: #274a7d;
	}

	.tab1 ul.cp_t li {
		border-bottom: 1px dotted #ddd;
		// background: url(../img/ico3.gif) no-repeat;
		padding-left: 20px;
		height: 35px;
		line-height: 35px;
	}
	.tab1 ul.cp_t li a {
		color: #000;
	}
	.tab1 ul.cp_t li a:hover {
		color: #274a7d;
		text-decoration: none;
	}

	.tab1 ul.cp_mc {
		padding: 20px;
	}
	.tab1 ul.cp_mc li {
		height: 180px;
	}
	.tab1 ul.cp_mc li p {
		height: 30px;
		line-height: 30px;
		text-align: center;
	}
	.tab1 ul.cp_mc li a {
		color: #000;
	}
	.tab1 ul.cp_mc li a:hover {
		color: #274a7d;
		text-decoration: none;
	}


}
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	.news_nr_left{
		padding: 0 rm(20);
		h1{
			text-align: center;
			padding-bottom: rm(10);
		}
		.news_inf{
			color: #999;
			padding-bottom: rm(10);
		}
		.news_nrn{
			p{
				line-height: rm(32);
				margin: 0 0 rm(10);
			}
		}
		img{
			display: block;
			margin: rm(20) 0;
		}
		.next{
			display: flex;
			height: rm(40);
			align-items: center;
			justify-content: space-between;
			padding-bottom: rm(80);
		}
	}
}
</style>